<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { EventTag } from '@/api'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Nagłówek',
              modelPath: [this, 'form', 'title'],
              required: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst po prawej stronie',
              modelPath: [this, 'form', 'subtitle'],
              required: true,
              multilingual: true
            }),
            new fields.ForeignKey({
              service: EventTag,
              label: 'Tagi wydarzeń',
              modelPath: [this, 'form', 'event_tags'],
              multiple: true,
              labelField: 'name',
              required: true
            })
          ]
        }
      ]
    }
  },
  data() {
    return {
      initialValues: {
        subtitle_pl: 'Spektakle',
        subtitle_en: 'Performances'
      }
    }
  }
}
</script>
